import BaseComponent from './BaseComponent'; 
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';
import $ from 'jquery';
registerLocale('es', es)

class Datepicker extends BaseComponent {

    loadOnConstructor(){
		
		const startDate = this.props.selected?this.props.selected:new Date();
    	this.state = {startDate };
   		this.handleChangeDatepicker = this.handleChangeDatepicker.bind(this);
    }

    handleChangeDatepicker(date, input_name){
    	let input =  $('[name="'+input_name+'"]');
    	input = input[0];

		this.setState(prevState => {
			return {
				...prevState,
				startDate: date
			}
		});
		if(this.props.onChange !== undefined){
			this.props.onChange(date, input);
		}
    }

    render() {
        return 	(
	<>
		<DatePicker className={this.props.className?this.props.className:undefined} 
				name={this.props.name?this.props.name:undefined} 
				id={this.props.id?this.props.id:undefined}
				style={this.props.style?this.props.style:undefined}
				
			showTimeSelect={!this.props.showTimeSelect?undefined:true} locale="es" dateFormat={this.props.dateFormat?this.props.dateFormat:"dd/MM/Y HH:mm:ss"}
			selected={this.props.selected?this.props.selected:new Date()}
			onChange={(value, e) => this.handleChangeDatepicker(value, this.props.name)} />
	</>
        )
    }
}

export default Datepicker;
